var exports = {
  "lf": "PerformancePaneButton__CGZ6qo",
  "$P": "PerformancePaneOverlay__mqSrJ_",
  "_y": "PerformancePaneBox__WaUALc",
  "T9": "PerformancePaneHeaderContainer__uqL3-a",
  "ve": "PerformancePaneHeading__I-ZVs-",
  "gF": "PerformancePaneControlsContainer__g9dkBS",
  "wp": "PerformancePaneTextInput__dzS_Fy",
  "S3": "PerformancePaneFormControl__iwrCs-",
  "I5": "PerformancePaneFormControlLabel__vYGGtd",
  "HO": "PerformancePaneSortButton__ecmkkp",
  "nF": "PerformancePaneActionMenuText__3do5pz",
  "oO": "PerformancePaneActionMenuItemBox__ZivUMM",
  "e$": "PerformancePaneActionMenuTextFlex__VmSa-P",
  "GP": "PerformancePaneTreeContainer__CSfybo",
  "Wm": "PerformancePaneTreeNav__sic5Jh",
};

module.exports = exports;
